import { FC } from 'react';

import { GiftCouponSummary } from '@shared/api/giftCoupon/giftCoupon.interface';

interface CancelSectionProps {
  cancellableCoupons: GiftCouponSummary[];
  selectedIds: Set<string>;
  isFullCancel: boolean;
  toggleSelectAll: () => void;
  setShowCancelConfirm: (v: boolean) => void;
}

export const CancelSection: FC<CancelSectionProps> = ({
  cancellableCoupons,
  selectedIds,
  isFullCancel,
  toggleSelectAll,
  setShowCancelConfirm,
}) => {
  return (
    <div className="flex shrink-0 items-center justify-between rounded-lg border border-red-200 bg-red-50 px-4 py-2.5">
      <div className="flex items-center gap-3">
        <label className="flex cursor-pointer items-center gap-2 text-sm font-medium text-gray-700">
          <input
            type="checkbox"
            checked={
              selectedIds.size === cancellableCoupons.length &&
              cancellableCoupons.length > 0
            }
            onChange={toggleSelectAll}
            className="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-500"
          />
          취소 가능 전체선택 ({cancellableCoupons.length}건)
        </label>
        {selectedIds.size > 0 && (
          <span className="text-xs text-red-600">
            {selectedIds.size}건 선택됨
            {isFullCancel ? ' (전체취소)' : ' (부분취소)'}
          </span>
        )}
      </div>
      {selectedIds.size > 0 && (
        <button
          onClick={() => setShowCancelConfirm(true)}
          className="rounded-lg bg-red-600 px-4 py-1.5 text-sm font-bold text-white hover:bg-red-700"
        >
          선택 쿠폰 취소 ({selectedIds.size}건)
        </button>
      )}
    </div>
  );
};
